<div class="block-wrap">
  <div class="header-wrapper" (click)="closeDialog()">
    <ion-icon name="chevron-down-outline" class="down-arrow"></ion-icon>
    <h4 class="whats-next-text">{{'whats-on.Lotto' | translate}}</h4>
    <img src="../../../assets/icon/arrow.png" />

  </div>
  <div class="what-vip-card">
    <div class="what-vip-card-title">
      Nickname Here
    </div>

    <div class="what-vip-card-banner" style="
    background-image: url('https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/app%2Fcover_img_200x200.webp?alt=media');
">
      <div class="what-vip-card-banner-avatar">
        <img src="../../../assets/icon/avatar.png" />
        <ion-input type="file"></ion-input>
      </div>
      <div class="what-vip-card-banner-badge">
        <img src="../../../assets/icon/silver-crown.png" />
        <p>VIP Silver</p>
      </div>
    </div>

    <div class="what-vip-card-body">

      <div class="lifestyle-progress">
        <p>Lifestyle XP 18,321 / <span>20,000</span></p>

        <div class="lifestyle-main">
          <div class="lifestyle-icon-icon">
            <img src="../../../assets/icon/bb_dimond.png" />
          </div>
          <div class="lifestyle-icon-label">Level 13</div>
        </div>
        <div class="quizz-progress">
          <ion-progress-bar value="0.5"></ion-progress-bar>
        </div>
        <div class="close-btn">
          <img src="../../../assets/icon/close.svg" />
        </div>
      </div>


      <div class="what-vip-card-body-text-box vip-membership-card">
        <h4 class="vip-card-title">VIP Membership</h4>
        <!-- swiper slider replacing ion-slides -->
        <swiper
          class="vip-slider test-slide"
          [config]="slideOpts"
          [pagination]="{ clickable: true }"
          [spaceBetween]="slideOpts.spaceBetween"
          [slidesPerView]="slideOpts.slidesPerView"
        >
          <ng-template swiperSlide class="slide-wrapper">
            <img src="../../../assets/icon/silver_c.png" alt="" class="prize-img" />
          </ng-template>

          <ng-template swiperSlide class="slide-wrapper">
            <img src="../../../assets/icon/gold_c.png" alt="" class="prize-img" />
          </ng-template>

          <ng-template swiperSlide class="slide-wrapper">
            <img src="../../../assets/icon/dim_c.png" alt="" class="prize-img" />
          </ng-template>

          <ng-template swiperSlide class="slide-wrapper">
            <img src="../../../assets/icon/pdim_c.png" alt="" class="prize-img" />
          </ng-template>

          <ng-template swiperSlide class="slide-wrapper">
            <img src="../../../assets/icon/bdim_c.png" alt="" class="prize-img" />
          </ng-template>
        </swiper>
      </div>


      <div class="what-vip-card-body-text-box">
        <h4 class="vip-card-title">Silver</h4>
        <p class="vip-card-dis">The Silver VIP Membership allows you to convert your small cash winnings into Credit and
          unlocks a Daily Reward! Tap the Info button on the card for more details. Swipe the screen to see what the
          Gold VIP Membership unlocks!</p>
      </div>
      <div class="line-br"></div>
      <div class="what-vip-card-body-text-box">
        <h4 class="vip-card-title">Lifestyle XP</h4>
        <p class="vip-card-dis">Your Lifestyle XP shows your overall progress on your Fantasy Millionaire journey. Earn
          Lifestyle XP to level up and unlock new features, including your VIP Membership Benefits.</p>
        <p class="vip-card-dis">All you need is an active syndicate!</p>
      </div>
      <div class="what-vip-card-body-text-box">
        <img src="../../../assets/icon/what-vip-card-body-text-box-img.png" />
      </div>
      <div class="what-vip-card-body-text-box">
        <h4 class="vip-card-title">How to improve your VIP Membership Benefits</h4>
        <p class="vip-card-dis">Improve your VIP Membership by exploring and engaging in all that Lotto Social has to
          offer:</p>

        <ul>
          <li><b>Post news</b> in your Social Stream.</li>
          <li><b>Build your Fantasy Millionaire Albums</b> (Coming Soon!).</li>
          <li><b>Join</b> Syndicates.</li>
          <li><b>Play</b> the Games!</li>
        </ul>

        <p class="vip-card-dis">The more you join in, the more Membership Benefits you will unlock, increasing your
          chances to win more for
          less!</p>

        <p class="vip-card-dis">Tap <b>'Menu'</b> below to find out more.</p>
      </div>

    </div>

    <div class="what-vip-card-footer">
      <ion-row>
        <ion-col>
          <div class="what-vip-card-footer-item item-info">
            <div class="what-vip-card-footer-item-icon">
              <img src="../../../assets/icon/blue_dimond.png" />
              <span>0</span>
            </div>
            <p>Community</p>
            <div class="info-quizz-progress">
              <ion-progress-bar value="0.5"></ion-progress-bar>
            </div>
          </div>
        </ion-col>
        <ion-col>
          <div class="what-vip-card-footer-item item-success">
            <div class="what-vip-card-footer-item-icon">
              <img src="../../../assets/icon/green_dimond.png" />
              <span>0</span>
            </div>
            <p>Fortune</p>
            <div class="success-quizz-progress">
              <ion-progress-bar value="0.5"></ion-progress-bar>
            </div>
          </div>
        </ion-col>
        <ion-col>
          <div class="what-vip-card-footer-item item-ornage">
            <div class="what-vip-card-footer-item-icon">
              <img src="../../../assets/icon/oringe_dimond.png" />
              <span>0</span>
            </div>
            <p>Gaming</p>
            <div class="ornage-quizz-progress">
              <ion-progress-bar value="0.5"></ion-progress-bar>
            </div>
          </div>
        </ion-col>
      </ion-row>
    </div>

  </div>

</div>